import { useEffect, useState } from "react";
import {
  listPartnerCampaigns,
  getPartnerCampaign,
  listPartnerInvoices,
} from "../../api/partnerPortalApi";

function PartnerCampaignsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [selected, setSelected] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    Promise.all([listPartnerCampaigns(), listPartnerInvoices()])
      .then(([campaignBody, invoiceBody]) => {
        setCampaigns(campaignBody.campaigns || []);
        setInvoices(invoiceBody.invoices || []);
        setStatus("ready");
      })
      .catch(() => {
        setCampaigns([]);
        setStatus("error");
      });
  }, []);

  const openCampaign = async (campaignId) => {
    const body = await getPartnerCampaign(campaignId);
    setSelected(body);
  };

  return (
    <div className="panel-card">
      <h2>Campaigns</h2>
      <p className="muted">Sponsor-visible campaign performance and invoice status.</p>

      {status === "loading" ? <p className="muted">Loading…</p> : null}
      {status === "error" ? <p className="muted">Unable to load campaigns.</p> : null}

      <ul className="cv-studio-list">
        {campaigns.map((c) => (
          <li key={c.id}>
            <button type="button" className="cv-button-link" onClick={() => openCampaign(c.id)}>
              {c.campaignName}
            </button>
            {" · "}
            <span className="status-badge">{c.status}</span>
            {" · "}
            Impr: {c.performance?.impressions ?? 0} · Clicks: {c.performance?.clicks ?? 0} · Leads:{" "}
            {c.performance?.leads ?? 0}
            {" · "}
            Invoice: {c.invoiceStatus}
          </li>
        ))}
      </ul>

      {selected ? (
        <div className="panel-card cv-studio-mini-card">
          <h3>{selected.campaign?.campaignName}</h3>
          <p>Status: {selected.campaign?.status}</p>
          <p>
            {selected.campaign?.startsAt || "—"} → {selected.campaign?.endsAt || "open"}
          </p>
          {selected.campaign?.sponsorVisibleNotes ? (
            <p>{selected.campaign.sponsorVisibleNotes}</p>
          ) : null}
          <p>
            CTR: {((selected.campaign?.performance?.ctr ?? 0) * 100).toFixed(1)}% · Leads:{" "}
            {selected.campaign?.performance?.leads ?? 0}
          </p>
          <p>Placements: {selected.placements?.length ?? 0}</p>
          <p>Attributed leads: {selected.attributedLeads?.length ?? 0}</p>
          <h4>Invoices</h4>
          <ul>
            {(selected.invoices || []).map((inv) => (
              <li key={inv.id}>
                {inv.invoiceNumber} · {inv.status} · {inv.amount} {inv.currency}
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      <h3>All invoices</h3>
      <ul className="cv-studio-list">
        {invoices.map((inv) => (
          <li key={inv.id}>
            {inv.invoiceNumber} · {inv.status} · {inv.amount} {inv.currency}
            {inv.campaignName ? ` · ${inv.campaignName}` : ""}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PartnerCampaignsPage;
